import { getContentAmount } from "@shared/functions/getContentAmount";
import styles from "./styles.module.sass";
import { formatTime } from "@shared/functions/formatTime";
import { pluralForm } from "@shared/functions/pluralForm";
import { SectionDto } from "@generated/models/SectionDto";

export type CourseContentInfoProps = {
	sections: SectionDto[];
};

const CourseContentInfo = ({ sections }: CourseContentInfoProps) => {
	const sectionsTotalTime = getContentAmount(sections, "sectionsTotalTime");
	const attachments = getContentAmount(sections, "attachments");
	const testsAmount = getContentAmount(sections, "test");
	const quizCardsAmount = getContentAmount(sections, "quiz");
	return (
		<div className={styles.mainInfo}>
			<h3>Этот курс включает:</h3>
			<ul className={styles.infoList}>
				<li>
					<span className={styles.contentAmount}>{formatTime(sectionsTotalTime, "HH:MM")}</span> видео, аудио
					и текстовых лекций
				</li>
				<li>
					<span className={styles.contentAmount}>{attachments}</span>{" "}
					{pluralForm(attachments, "ресурс", "ресурса", "ресурсов")} для скачивания
				</li>
				<li>
					<span className={styles.contentAmount}>{testsAmount}</span>{" "}
					{pluralForm(testsAmount, "практический тест", "практических теста", "практических тестов")}
				</li>
				<li>
					<span className={styles.contentAmount}>{quizCardsAmount}</span>{" "}
					{pluralForm(quizCardsAmount, "квиз-карточка", "квиз-карточки", "квиз-карточек")}
				</li>
			</ul>
		</div>
	);
};

export default CourseContentInfo;
